import React from 'react';
import DOMPurify from 'dompurify';

const FOOTER_HTML = DOMPurify.sanitize(
  'Made in house of <a href="https://flutterfox.in" target="_blank" rel="dofollow" style="color:#f97316;font-weight:600;text-decoration:none">Flutter Fox</a> &#10084;&#65039;',
  { ADD_ATTR: ['target', 'rel'] }
);

const FOOTER_HTML_PURPLE = DOMPurify.sanitize(
  'Made in house of <a href="https://flutterfox.in" target="_blank" rel="dofollow" style="color:#a855f7;font-weight:600;text-decoration:none">Flutter Fox</a> &#10084;&#65039;',
  { ADD_ATTR: ['target', 'rel'] }
);

export function FlutterFoxFooter({ variant = 'orange', className = '', testId = '' }) {
  const html = variant === 'purple' ? FOOTER_HTML_PURPLE : FOOTER_HTML;
  return (
    <p
      className={`text-xs text-slate-400 ${className}`}
      data-testid={testId || 'flutterfox-footer'}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}
